"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const Login2FA_1 = __importDefault(require("@/features/login2fa/containers/Login2FA"));
const login2FASelector_1 = require("@/features/login2fa/selectors/login2FASelector");
// export const Login2faRenderInner = (props) => {
const Login2faRenderInner = props => {
    const login2FAData = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    return login2FAData.showLayout && react_1.default.createElement(Login2FA_1.default, null);
};
exports.default = Login2faRenderInner;
